// extracted by mini-css-extract-plugin
module.exports = {"labelAndError":"InputWrapper_labelAndError__ZGrWF","error":"InputWrapper_error__U_YyL","errorIcon":"InputWrapper_errorIcon__Oj1Qk"};